// extracted by mini-css-extract-plugin
export default {"sectionContent":"Offer_sectionContent__4xZJ1","offer":"Offer_offer__vbwem","scroll":"Offer_scroll__qFm6W"};